import React, { FC } from 'react';
import { APIS } from '../../../../lib/constants/apis';
import ApplicationHeading from '../../../../pages/private/online-antrag/application-heading/ApplicationHeading';
import CreateForm from '../../../ui-component/form-component/create-form/CreateForm';

// import schemas
import Schema from '../../../../lib/paths/person_FULL_Paths.json';
const P = Schema.attributes;

const PersonDaten: FC<{
	formValue: any;
	updateFunction: (_key: string, _value: any) => void;
	personDatenError: any;
}> = ({ formValue, updateFunction, personDatenError }) => {
	return (
		<>
			<ApplicationHeading
				title='Personendaten'
				description='Bitte vervollständigen Sie die Angaben zu Ihrer Person.
'
			/>

			<CreateForm
				formValues={formValue}
				formStruc={formStruc()}
				updateFormValuesFunc={updateFunction}
				formErrors={personDatenError}
				api={APIS.Person}
			/>
		</>
	);
};

export default PersonDaten;

const formStruc = () => {
	return [
		{
			fields: [P.Titel, { ...P.Geschlecht, required: true }],
			userProps: { columnToDivide: 1 },
		},
		{
			fields: [
				{ ...P.Vorname, required: true },
				{ ...P.Nachname, required: true },
			],
			userProps: { columnToDivide: 1 },
		},
		{
			fields: [
				{ ...P.Geburtsdatum, label: 'Geburtsdatum *', required: true },
				{ ...P.Staatsbuergerschaft, required: true },
			],

			userProps: { columnToDivide: 1 },
		},
		{
			fields: [
				{ ...P.E_Mail, required: true },
				{ ...P.Telefon, required: true },
			],
			userProps: { columnToDivide: 1 },
		},
		{
			fields: [
				{ ...P.Adressdaten.schema.attributes.Strasse_Und_Hausnummer, required: true },
				{ ...P.Adressdaten.schema.attributes.PLZ, required: true },
			],
			userProps: { columnToDivide: 1 },
		},
		{
			fields: [
				{ ...P.Adressdaten.schema.attributes.Ort, required: true },
				{ ...P.Adressdaten.schema.attributes.Bundesland, required: true },
			],
			userProps: { columnToDivide: 1 },
		},
	];
};
